import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { Section } from './Shared';
import { WHATSAPP_URL, WhatsAppIcon } from './WhatsAppButton';
export function Guarantee() {
  return <Section className="max-w-3xl" data-id="element-86" data-mp="32o4d0g3lai96">
      <div className="glass-panel rounded-3xl border-brand-forest/30 p-8 text-center md:p-12" data-id="element-87" data-mp="32p5mig4yiwos">
        <ShieldCheckIcon className="mx-auto h-16 w-16 text-brand-forest" data-id="element-88" data-mp="36q9354utwwr2" />
        <h2 className="mt-5 font-display text-3xl font-bold text-brand-ink" data-id="element-89" data-mp="3ueim7z0nr6ei">
          GARANTÍA 7 DÍAS — SIN PREGUNTAS
        </h2>
        <p className="mt-5 text-brand-text" data-id="element-90" data-mp="37fpyt5yq9xf">
          Abrís el Botiquín. Aplicás las fichas. Lo usás en tu consultorio o en
          casa.
        </p>
        <p className="mt-4 text-brand-text" data-id="element-91" data-mp="3qd6qdbr6xoxv">
          Si en 7 días no es exactamente lo que esperabas: devolución del 100%
          sin formularios, sin drama, sin preguntas.
        </p>
        <p className="mt-6 font-semibold text-brand-forest" data-id="element-92" data-mp="2ey9yzv7jannc">
          Tasa de devoluciones: menos del 1%.
        </p>
      </div>
    </Section>;
}
export function Footer() {
  return <footer className="border-t border-brand-gold/35 bg-brand-ink py-12 text-brand-paper" data-id="element-93" data-mp="3lbdecxo1ahnx">
      <div className="mx-auto max-w-7xl px-4 text-center sm:px-6 lg:px-8" data-id="element-94" data-mp="3gck0h44u4on8">
        <h3 className="font-display text-3xl font-bold text-brand-goldLight" data-id="element-95" data-mp="3v9b0nfmc24dw">
          LUMEN AKASHA™
        </h3>
        <p className="mx-auto mt-3 max-w-2xl text-white/80" data-id="element-96" data-mp="3q7bwi3irr3fw">
          La herramienta clínica N°1 de digitopuntura para terapeutas en
          Argentina.
        </p>
        <p className="mx-auto mt-2 max-w-2xl text-white/70" data-id="element-97" data-mp="32w3duq73ebb">
          Porque aplicar Medicina Tradicional China con excelencia no debería
          costarte la seguridad ni la eficacia de tu consultorio.
        </p>
        <div className="mt-8 flex flex-col items-center justify-center gap-3 text-sm text-brand-goldLight sm:flex-row sm:gap-7" data-id="element-98" data-mp="cu8uul8302gt">
          <a className="transition-colors hover:text-brand-paper" href="mailto:soportelumenakasha@gmail.com" data-id="element-99" data-mp="qr5gm89cetqu">
            soportelumenakasha@gmail.com
          </a>
          <a className="transition-colors hover:text-brand-paper" href="https://instagram.com/lumen.akasha" data-id="element-100" data-mp="tta0kieet1ya">
            @lumen.akasha
          </a>
          <a className="inline-flex items-center gap-1.5 transition-colors hover:text-brand-paper" href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" data-id="element-101" data-mp="13r7mgz8sqmnq">
            <WhatsAppIcon className="h-4 w-4" data-id="element-102" data-mp="1hkp6el5ea1ea" />
            WhatsApp 11 5339-9780
          </a>
          <a className="transition-colors hover:text-brand-paper" href="https://www.lumenakasha.com" data-id="element-103" data-mp="1hmibvx49ufkp">
            www.lumenakasha.com
          </a>
        </div>
        <div className="mt-10 space-y-2 text-xs text-white/50" data-id="element-104" data-mp="1rgiqqqpcuz6m">
          <p data-id="element-105" data-mp="3ocpxniknc1y8">
            © Lumen Akasha™ 2026 — Todos los derechos reservados. Prohibida la
            reproducción y redistribución sin autorización expresa.
          </p>
          <p data-id="element-106" data-mp="2afdm9nra1su2">
            Ley 25.326 — Protección de Datos Personales — República Argentina
          </p>
        </div>
        <p className="mt-8 font-serif text-sm italic text-brand-goldLight/75" data-id="element-107" data-mp="25nltd6knfb0r">
          “El terapeuta que tiene un sistema aplica con confianza. El que aplica
          con confianza genera resultados. El que genera resultados crece.”
        </p>
      </div>
    </footer>;
}